import {  t  } from "@/client/libs/dummy-i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@stackmorph/ui";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Is StackMorph really free?",
    answer: "Yes! Create unlimited resumes at no cost. We believe everyone deserves access to professional resume tools.",
  },
  {
    question: "How does the AI writing assistant work?",
    answer: "Our AI analyzes your experience and suggests improvements to make your resume stand out. It adapts to your industry and role.",
  },
  {
    question: "Can I export my resume as PDF?",
    answer: "Absolutely. Download high-quality PDFs optimized for ATS systems, or share a live link with recruiters.",
  },
  {
    question: "Is my data private and secure?",
    answer: "100%. Your resume data stays on your device. We use end-to-end encryption and never sell your information.",
  },
  {
    question: "Do I need to create an account?",
    answer: "No signup required to try! Create an account only when you want to save your work and access it from multiple devices.",
  },
  {
    question: "What file formats are supported?",
    answer: "Export to PDF, DOC X, or share a live web link. All formats are ATS-friendly and optimized for applicant tracking systems.",
  },
];

export const FAQSection = () => {
  return (
    <section className="relative overflow-hidden bg-background py-24">
      <div className="container mx-auto px-6">
        <div className="grid gap-12 lg:grid-cols-5">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
          >
            <h2 className="mb-4 text-4xl font-bold tracking-tight lg:text-5xl">
              {t`Quick answers`}
            </h2>
            <p className="text-lg text-muted-foreground">
              {t`Everything you need to know about StackMorph Resume Builder`}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <Accordion collapsible type="single" className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="rounded-2xl border border-border/50 bg-background/50 px-6 backdrop-blur-xl data-[state=open]:border-primary/30"
                >
                  <AccordionTrigger className="text-left font-semibold hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
